import React from "react";
import "./Help.css";

function Help() {
  return (
    <div className="help">
      <div className="content">
        <h3>We are always happy to help </h3>
        <p>To find solutions that fits your needs</p>
      </div>
    </div>
  );
}

export default Help;
